import React from 'react';
import colors from '@nib-components/colors';
import {TickInCircleSystemIcon, InfoSystemIcon, WarningSystemIcon, CrossInCircleSystemIcon} from '@nib/icons';
import {typeValues} from './types';

export const pickColor = (alertType: typeValues): string => {
  switch (alertType) {
    case 'info':
    default:
      return '#005bb9';
    case 'error':
      return '#c81414';
    case 'success':
      return '#007800';
    case 'warning':
      return colors.kate;
  }
};

export const pickBackgroundColor = (alertType: typeValues): string => {
  switch (alertType) {
    case 'info':
    default:
      return '#ebf2fa';
    case 'error':
      return '#fcedeb';
    case 'success':
      return '#ebf6ee';
    case 'warning':
      return '#fff9eb';
  }
};

export const renderIcon = (type: typeValues, isIconColored: boolean): JSX.Element => {
  const fill = isIconColored ? pickColor(type) : '#ffffff';

  switch (type) {
    case 'info':
    default:
      return <InfoSystemIcon fill={fill} />;
    case 'error':
      return <CrossInCircleSystemIcon fill={fill} />;
    case 'success':
      return <TickInCircleSystemIcon fill={fill} />;
    case 'warning':
      return <WarningSystemIcon fill={colors.doc} />;
  }
};
